import { watch } from 'vue';
import { usePersisted } from './use_persisted.js';

const themes = [
  { id: 'range',     label: 'Range' },
  { id: 'precision', label: 'Precision' },
  { id: 'field',     label: 'Field' },
  { id: 'classic',   label: 'Classic' },
  { id: 'dark',      label: 'Dark' },
];

const currentTheme = usePersisted('app-theme', 'range', {
  validate: (id) => themes.some(t => t.id === id),
});

watch(currentTheme, (id) => {
  document.documentElement.setAttribute('data-theme', id);
}, { immediate: true });

function setTheme(id) {
  currentTheme.value = id;
}

export function useTheme() {
  return {
    themes,
    currentTheme,
    setTheme,
  };
}
